import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import {store} from './lib/store'
import {router} from './lib/router'

Vue.config.productionTip = false;

store.dispatch('setEnviroment')
store.dispatch('readToken')

new Vue({
	vuetify,
	render: h => h(App),
	router,
	store
}).$mount('#app')
